var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jwsDecode as decodeToken } from './jwsDecode';
import memoize from 'lodash/memoize';
import { OTPType } from './types';
import { EventEmitter } from 'events';
import { Mutex } from './mutex';
import { MemoryStorage } from './storages/MemoryStorage';
import { noopLogger } from './noopLogger';
import { Transport } from './Transport';
var Keycloak = (function (_super) {
    __extends(Keycloak, _super);
    function Keycloak(config, initState, storage, logger, transport) {
        if (storage === void 0) { storage = new MemoryStorage(); }
        if (logger === void 0) { logger = noopLogger; }
        if (transport === void 0) { transport = new Transport(config, logger); }
        var _this = _super.call(this) || this;
        _this.storage = storage;
        _this.logger = logger;
        _this.transport = transport;
        _this.timeCorrection = 0;
        _this.waitForRefresh = 500;
        _this.decode = memoize(function (token, tokenType) {
            try {
                var result = decodeToken(token);
                return result;
            }
            catch (error) {
                _this.logger.error("Invalid " + tokenType + " token: " + token);
                throw error;
            }
        });
        _this.scheduleRefresh = function (_a) {
            var parsedAccessToken = _a.parsedAccessToken, refreshToken = _a.refreshToken;
            _this.scheduledRefreshId && clearTimeout(_this.scheduledRefreshId);
            var randomRefreshMoment = Math.random() * 1000;
            var HALF = 2;
            var tokenLifeTime = Math.floor(parsedAccessToken.exp * 1000) - _this.now();
            var timeout = Math.max(_this.minLifetime, (tokenLifeTime / HALF)) + randomRefreshMoment;
            _this.scheduledRefreshId = setTimeout(function () { return _this.refreshTokens(refreshToken, false); }, timeout);
        };
        _this.watchLogout = function () {
            var emitIfLoggedOut = function () {
                var refreshToken = _this.storage.getTokens().refreshToken;
                if (!refreshToken) {
                    _this.emit('remove:tokens');
                    _this.logger.debug('Token storage is empty. Logged out');
                }
            };
            _this.scheduledLogoutWatcherId = setInterval(emitIfLoggedOut, _this.logoutWatcherTimeout);
            _this.once('remove:tokens', _this.watchLogin);
        };
        _this.watchLogin = function () {
            _this.scheduledLogoutWatcherId && clearInterval(_this.scheduledLogoutWatcherId);
            _this.once('change:tokens', _this.watchLogout);
        };
        _this.startLogoutWatcher = function () {
            _this.logger.debug('Watching logout has been started');
            _this.getTokens()
                .then(_this.watchLogout)
                .catch(_this.watchLogin);
            return _this.stopLogoutWatcher;
        };
        _this.stopLogoutWatcher = function () {
            _this.scheduledLogoutWatcherId && clearInterval(_this.scheduledLogoutWatcherId);
            _this.removeListener('change:tokens', _this.watchLogout);
            _this.removeListener('remove:tokens', _this.watchLogin);
            _this.logger.debug('Watching logout has been stopped');
        };
        if (config.logLevel) {
            _this.logger.setDefaultLevel(config.logLevel);
        }
        _this.logoutWatcherTimeout = config.logoutWatcherTimeout || 5000;
        _this.maxTimeForRefresh = config.maxTimeForRefresh || 2000;
        _this.minLifetime = config.minLifetime ? config.minLifetime * 1000 : 0;
        _this.mutex = new Mutex(_this.waitForRefresh, _this.maxTimeForRefresh, function () { return _this.now(); }, _this.storage);
        if (initState) {
            var serverTimestamp = initState.serverTimestamp, tokens = __rest(initState, ["serverTimestamp"]);
            _this.timeCorrection = serverTimestamp ? serverTimestamp - Date.now() : 0;
            if (tokens.accessToken) {
                try {
                    _this.setTokens(tokens);
                    _this.logger.debug('Constructor: init tokens to storage');
                }
                catch (error) {
                    _this.logger.error('Cannot set initial tokens', error);
                }
            }
            else if (tokens.refreshToken) {
                _this.refreshTokens(tokens.refreshToken);
            }
            else {
                _this.removeTokensFromStorage();
            }
        }
        return _this;
    }
    Keycloak.prototype.now = function () {
        return Date.now() + this.timeCorrection;
    };
    Keycloak.prototype.isTokenExpired = function (expiredAt) {
        if (expiredAt === void 0) { expiredAt = 0; }
        var lifetime = (expiredAt * 1000) - this.now();
        return lifetime < this.minLifetime;
    };
    Keycloak.prototype.setTokens = function (tokens) {
        var parsedAccessToken = this.decode(tokens.accessToken, 'access');
        var parsedRefreshToken = this.decode(tokens.refreshToken, 'refresh');
        this.storage.setTokens(tokens);
        this.logger.debug('emit change');
        this.emit('change:tokens', __assign(__assign({}, tokens), { parsedAccessToken: parsedAccessToken,
            parsedRefreshToken: parsedRefreshToken }));
    };
    Keycloak.prototype.authorizeByFirstFactor = function (username, password, product, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                response = this.transport.authorizeByFirstFactor(username, password, product, locale);
                this.tokenPromise = response.then(function (data) {
                    if (data.otpType === OTPType.OTP_DISABLED) {
                        _this.setTokens(data.tokens);
                        _this.logger.debug('AuthorizeByFirstFactor: tokens has been set to storage');
                    }
                }).catch(function () { });
                return [2, response];
            });
        });
    };
    Keycloak.prototype.authorizeBySecondFactor = function (secondFactorRequestId, code) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                response = this.transport.authorizeBySecondFactor(secondFactorRequestId, code);
                this.tokenPromise = response.then(function (data) {
                    _this.setTokens(data);
                    _this.logger.debug('AuthorizeBySecondFactor: tokens has been set to storage');
                }).catch(function () { });
                return [2, response];
            });
        });
    };
    Keycloak.prototype.getTokens = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var e_1, tokens, parsedAccessToken, parsedRefreshToken, data, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.tokenPromise) return [3, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.tokenPromise];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.logger.error(e_1);
                        return [3, 4];
                    case 4:
                        tokens = this.storage.getTokens();
                        if (!tokens.accessToken && !tokens.refreshToken) {
                            throw new Error('User is not authorized');
                        }
                        try {
                            parsedAccessToken = this.decode(tokens.accessToken, 'access');
                            parsedRefreshToken = this.decode(tokens.refreshToken, 'refresh');
                        }
                        catch (e) {
                            this.removeTokensFromStorage();
                            throw new Error("Get Tokens: " + e.message + " => tokens removed from storage");
                        }
                        if (!this.isTokenExpired(parsedAccessToken.exp)) return [3, 9];
                        data = void 0;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, , 8]);
                        return [4, this.refreshTokens(tokens.refreshToken)];
                    case 6:
                        data = _b.sent();
                        return [3, 8];
                    case 7:
                        e_2 = _b.sent();
                        throw new Error("Get Tokens: accessToken is expired, cannot refresh due to " + ((_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.details) === null || _a === void 0 ? void 0 : _a.message));
                    case 8: return [2, __assign(__assign({}, data), { parsedAccessToken: this.decode(data.accessToken, 'access'), parsedRefreshToken: this.decode(data.refreshToken, 'refresh') })];
                    case 9: return [2, __assign(__assign({}, tokens), { parsedAccessToken: parsedAccessToken,
                            parsedRefreshToken: parsedRefreshToken })];
                }
            });
        });
    };
    Keycloak.prototype.refreshTokens = function (refreshToken, isBlockingRequest) {
        if (isBlockingRequest === void 0) { isBlockingRequest = true; }
        return __awaiter(this, void 0, void 0, function () {
            var parsedRefreshToken, response;
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    parsedRefreshToken = this.decode(refreshToken, 'refresh');
                }
                catch (e) {
                    this.removeTokensFromStorage();
                    throw new Error("Refresh Tokens: " + e.message + " => tokens removed from storage");
                }
                if (this.isTokenExpired(parsedRefreshToken.exp)) {
                    this.logout();
                    throw new Error('Refresh Tokens: refreshToken is expired => logged out');
                }
                response = this.mutex.runExclusive(function () { return __awaiter(_this, void 0, void 0, function () {
                    var refreshTokenFromStorage, tokenPromise;
                    var _this = this;
                    return __generator(this, function (_a) {
                        refreshTokenFromStorage = this.storage.getRefreshToken();
                        if (refreshTokenFromStorage && refreshTokenFromStorage !== refreshToken) {
                            return [2, this.storage.getTokens()];
                        }
                        tokenPromise = this.transport.refreshTokens(refreshToken).then(function (data) {
                            _this.setTokens(data);
                            _this.logger.debug('Refresh Tokens: tokens has been set to storage');
                            return data;
                        }).catch(function (error) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                                _this.logger.warn({
                                    tokens: _this.storage.getTokens(),
                                    removed: new Date(),
                                    message: error.message,
                                    response: error.response,
                                });
                                _this.removeTokensFromStorage();
                                _this.logger.warn('Refresh Tokens: tokens has been deleted from storage due to server 401 error');
                                _this.emit('error', {
                                    message: (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.message,
                                    attributes: (_g = (_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.details) === null || _g === void 0 ? void 0 : _g.attributes
                                });
                            }
                            throw error;
                        });
                        if (isBlockingRequest) {
                            this.tokenPromise = tokenPromise;
                        }
                        return [2, tokenPromise];
                    });
                }); });
                return [2, response];
            });
        });
    };
    Keycloak.prototype.removeTokensFromStorage = function () {
        this.storage.removeTokens();
        this.emit('remove:tokens');
    };
    Keycloak.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens, newTokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tokens = this.storage.getTokens();
                        this.removeTokensFromStorage();
                        if (!this.tokenPromise) return [3, 2];
                        return [4, this.tokenPromise];
                    case 1:
                        _a.sent();
                        newTokens = this.storage.getTokens();
                        if (newTokens.refreshToken) {
                            tokens = newTokens;
                            this.removeTokensFromStorage();
                        }
                        _a.label = 2;
                    case 2:
                        this.logger.debug('Logout: tokens has been removed from storage');
                        return [2, this.transport.logout(tokens.accessToken)];
                }
            });
        });
    };
    Keycloak.prototype.startAutoRefresher = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.logger.debug('Auto refreshing tokens has been started');
                this.on('change:tokens', this.scheduleRefresh);
                this.on('remove:tokens', function () { return _this.scheduledRefreshId && clearTimeout(_this.scheduledRefreshId); });
                this.getTokens().then(function (tokens) { return _this.scheduleRefresh(tokens); }).catch(function () { });
                return [2, this.stopAutoRefresher];
            });
        });
    };
    Keycloak.prototype.stopAutoRefresher = function () {
        this.scheduledRefreshId && clearTimeout(this.scheduledRefreshId);
        this.removeListener('change:tokens', this.scheduleRefresh);
        this.logger.debug('Auto refreshing tokens has been stopped');
    };
    return Keycloak;
}(EventEmitter));
export { Keycloak };
//# sourceMappingURL=Keycloak.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/keycloak/es/Keycloak.js
// module id = 1395
// module chunks = 118